<template>
  <section class="default-container">
    <div class="content">
      <div class="content-left">
        <div class="left-title">회원사업</div>
        <div class="menu-wrap">
          <div v-for="(menu, index) in menuList" :key="'menu' + index" class="menu-item">
            <div :class="['menu-name', {on: menu.selected}]" @click="menuClick(index)">{{ menu.name }}</div>
            <div v-show="menu.subMenuShow" class="sub-menu__wrap">
              <div
                v-for="(subMenu, idx) in menu.subMenu"
                :key="'subMenu' + idx"
                :class="['sub-menu__item', {on: subMenu.selected}]"
                @click="subMenuClick(index, idx)"
              >
                ・ {{ subMenu.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-right">
        <Tab1 v-if="menuList[0].selected === true" :menu="menuList[0].subMenu.findIndex(item => item.selected)" />
        <Tab2 v-if="menuList[1].selected === true" :menu="menuList[1].subMenu.findIndex(item => item.selected)" />
        <Tab3 v-if="menuList[2].selected === true" :menu="menuList[2].subMenu.findIndex(item => item.selected)" />
        <Tab4 v-if="menuList[3].selected === true" :menu="menuList[3].subMenu.findIndex(item => item.selected)" />
      </div>
    </div>
  </section>
</template>

<script>
import {useMembershipStore} from '~/store/membership/index.js'
import {useMemberStore} from '~/store/member/index.js'
import Tab1 from '~/components/membership-business/tab/Tab1.vue'
import Tab2 from '~/components/membership-business/tab/Tab2.vue'
import Tab3 from '~/components/membership-business/tab/Tab3.vue'
import Tab4 from '~/components/membership-business/tab/Tab4.vue'
import {useHead} from '#imports'

export default {
  name: 'MembershipBusinessIndex',
  components: {Tab1, Tab2, Tab3, Tab4},
  setup() {
    const memberStore = useMemberStore()
    const membershipStore = useMembershipStore()
    // 사이트 링크용 메타 태그 설정
    useHead({
      title: '회원사업 | 한국인사관리협회',
      meta: [
        {
          name: 'description',
          content: '한국인사관리협회 회원만을 위한 월례미팅, 교류회, CHO 포럼 등 다양한 인사/HR 전문가 역량 강화 프로그램을 소개합니다.'
        },
        {
          property: 'og:title', // Open Graph 태그 (카카오톡, 페이스북 등 공유 시 미리보기 제목)
          content: '회원사업 | 한국인사관리협회'
        },
        {
          property: 'og:description', // Open Graph 태그 (공유 시 미리보기 설명)
          content: '한국인사관리협회 회원만을 위한 월례미팅, 교류회, CHO 포럼 등 다양한 인사/HR 전문가 역량 강화 프로그램을 소개합니다.'
        }
      ],
      // 쿼리 파라미터가 붙더라도 항상 이 URL이 표준임을 알립니다.
      link: [
        { rel: 'canonical', href: 'https://insabank.com/membership-business' }
      ]
    })
    return {
      memberStore,
      membershipStore
    }
  },
  data() {
    return {
      isAuth: false,
      menuList: [
        {
          name: '한국인사관리자 월례미팅',
          selected: false,
          subMenuShow: false,
          subMenu: [
            {name: '회원가입 안내', selected: false},
            {name: '이달의 미팅', selected: false},
            {name: '미팅 동영상', selected: false},
            {name: '정보자료', selected: false},
            {name: '포토존', selected: false}
          ]
        },
        {
          name: '교육연수담당자 월례미팅',
          selected: false,
          subMenuShow: false,
          subMenu: [
            {name: '회원가입 안내', selected: false},
            {name: '이달의 미팅', selected: false},
            {name: '미팅 동영상', selected: false},
            {name: '정보자료', selected: false},
            {name: '포토존', selected: false}
          ]
        },
        {
          name: '인사팀(부)장 교류회',
          selected: false,
          subMenuShow: false,
          subMenu: [
            {name: '회원가입 안내', selected: false},
            {name: '이달의 교류회', selected: false},
            {name: '교류회 동영상', selected: false},
            {name: '정보자료', selected: false},
            {name: '포토존', selected: false}
          ]
        },
        {
          name: 'Korea CHO Forum',
          selected: false,
          subMenuShow: false,
          subMenu: [
            {name: '회원가입 안내', selected: false},
            {name: '이달의 포럼', selected: false},
            {name: '포럼 동영상', selected: false},
            {name: '정보자료', selected: false},
            {name: '포토존', selected: false}
          ]
        }
      ],
      scriptKey: 'onseminar-script'
    }
  },

  watch: {
    $route: {
      handler: function () {
        this.menuController()
      },
      deep: true
    }
  },
  async mounted() {
    if (!document.getElementById(this.scriptKey)) {
      const scriptElement = document.createElement('script')
      scriptElement.id = this.scriptKey
      scriptElement.src = 'https://onseminar.com/api2/onseminar.min.js'
      scriptElement.defer = true
      document.head.appendChild(scriptElement)
    }
    this.isAuth = this.memberStore.isAuthenticated
    this.menuController()
  },
  beforeUnmount() {
    const scriptElement = document.getElementById(this.scriptKey)
    // 페이지를 나갈 때 스크립트 제거
    if (scriptElement) {
      document.head.removeChild(scriptElement)
    }
  },
  methods: {
    menuController() {
      const urlParams = new URLSearchParams(window.location.search)
      const menuIndex = parseInt(urlParams.get('menu') || '0')
      const subMenuIndex = parseInt(urlParams.get('subMenu') || '0')

      // 기존 메뉴 서브메뉴는 초기화
      this.menuList.forEach(menu => {
        menu.selected = false
        menu.subMenuShow = false
        if (menu.subMenu) {
          menu.subMenu.forEach(subMenu => {
            subMenu.selected = false
          })
        }
      })

      // 선택된 메뉴와 서브메뉴의 상태 변경
      if (this.menuList[menuIndex]) {
        this.menuList[menuIndex].selected = true
        this.menuList[menuIndex].subMenuShow = true

        if (this.menuList[menuIndex].subMenu[subMenuIndex]) {
          this.menuList[menuIndex].subMenu[subMenuIndex].selected = true
        }
      }

      // // 메뉴와 서브메뉴가 모두 0 이라면 type을 쿼리에 붙여준다
      // if (menuIndex === 0 && subMenuIndex === 0) {
      //   this.$router.push(`/membership-business?menu=0&subMenu=0&type=`)
      // }
    },
    menuClick(index) {
      switch (index) {
        case 0:
          this.$router.push('/membership-business?menu=0&subMenu=0&type=')
          break
        case 1:
          this.$router.push('/membership-business?menu=1&subMenu=0')
          break
        case 2:
          this.$router.push('/membership-business?menu=2&subMenu=0')

          break
        case 3:
          this.$router.push('/membership-business?menu=3&subMenu=0')
          break
      }

      window.scrollTo({top: 0})
    },
    async subMenuClick(index, idx) {
      // 회원사업구독 아니여도 접근 가능한 idx 리스트 ( 회원가입 안내, 이달의 미팅, 정보자료, 포토존 )
      const freeAccessIdx = [0, 1, 3, 4]
      if (freeAccessIdx.includes(idx)) {
        this.$router.push(`/membership-business?menu=${index}&subMenu=${idx}`)
        window.scrollTo({top: 0})
      } else {
        if (!this.isAuth) {
          alert('로그인 후 이용해 주세요.')
          return
        }
        // 회원사업 타입
        const memberTypeMap = {
          0: 'MMT01',
          1: 'MMT02',
          2: 'MMT03',
          3: 'MMT04'
        }
        // 구독여부 체크
        const {data} = await this.membershipStore.getMembershipSubscribe(memberTypeMap[index])
        const isSubscribe = data.isSubscribe
        if (!isSubscribe && !freeAccessIdx.includes(idx)) {
          alert('회원사업 가입 후 이용 가능합니다.')
          return
        }
        this.$router.push(`/membership-business?menu=${index}&subMenu=${idx}`)
        window.scrollTo({top: 0})
      }
    }
  }
}
</script>

<style scoped lang="scss">
.default-container {
  padding: 48px 0 100px;

  .content {
    display: flex;
    gap: 24px;
    position: relative;
    margin-top: 48px;

    .content-left {
      min-width: 222px;
      position: sticky;
      top: 40px;
      left: 0;
      height: 600px;

      .left-title {
        color: #121212;
        font-family: 'Godo', sans-serif;
        border-bottom: 1px solid #121212;
        padding-bottom: 24px;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 125%; /* 30px */
      }

      .menu-name {
        padding: 24px;
        border-bottom: 1px solid #dbdbdb;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: 125%; /* 20px */
        cursor: pointer;

        &:hover {
          color: #0058aa;
        }

        &.on {
          font-weight: 700;
          color: #0058aa;
        }
      }

      .sub-menu__item {
        padding: 12px 24px;
        cursor: pointer;
        color: #606060;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 125%; /* 17.5px */
        &.on {
          font-weight: 700;
          color: #0058aa;
        }

        &:hover {
          background: #f8fbfd;
          color: #0058aa;
        }

        &:last-child {
          border-bottom: 1px solid #dbdbdb;
        }
      }
    }

    .content-right {
      width: 100%;
    }
  }
}
</style>
